import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({ template: '' })
export abstract class Subscriber implements OnDestroy {
    private subscriptions: Subscription[] = [];
    private indexedSubscriptions: { [key: string]: Subscription } = {};

    constructor() {}

    protected addSubscription(sub: Subscription, key: string = null) {
        this.subscriptions.push(sub);
        if (key) {
            this.indexedSubscriptions[key] = sub;
        }
    }
    protected addBatchSubscriptions(...subs: Array<Subscription>) {
        subs.forEach((sub) => this.addSubscription(sub));
    }

    cleanSubscriptions() {
        this.subscriptions.forEach((sub) => {
            if (sub && !sub.closed) {
                sub.unsubscribe();
            }
        });
        this.subscriptions = [];
        this.indexedSubscriptions = {};
    }

    ngOnDestroy() {
        this.cleanSubscriptions();
    }
}
